import { render, staticRenderFns } from "./LimitActionModal.vue?vue&type=template&id=aea78268"
import script from "./LimitActionModal.vue?vue&type=script&lang=js"
export * from "./LimitActionModal.vue?vue&type=script&lang=js"
import style0 from "./LimitActionModal.vue?vue&type=style&index=0&id=aea78268&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports